import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { handleServerError } from '@/common/utils/handleServerError'
import { PaymentModalityType } from '@/features/companies/types/companies.type'
import { useReviewCompanyGovernmentAllocationEntry } from '@/features/privateCompanies/hooks/useReviewCompanyGovernmentAllocationEntry'
import { useIsMutating, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ApproveGovernmentAllocationEntryModalProps {
  governmentAllocationKind?: PaymentModalityType
}

export const ApproveGovernmentAllocationEntryModal = ({
  governmentAllocationKind,
}: ApproveGovernmentAllocationEntryModalProps) => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  const isMutating = !!useIsMutating()

  const [isOpen, setIsOpen] = useState(false)
  const [baseError, setBaseError] = useState('')

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocationEntry', id] })
    setIsOpen(false)
  }

  const onError = (error: ErrorResponse) => {
    handleServerError({ error, setBaseError })
  }

  const { mutate: approveGovernmentAllocationEntry, isPending: approveGovernmentAllocationEntryIsPending } =
    useReviewCompanyGovernmentAllocationEntry({
      governmentAllocationId: id,
      state: 'approved',
      onSuccess,
      onError,
    })

  const onSubmit = () => {
    setBaseError('')
    approveGovernmentAllocationEntry({})
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={onSubmit}
      Trigger={
        <Button type="button" className="w-[164px]" disabled={isMutating}>
          Aprovar
        </Button>
      }
      useCancellableFooter
      confirmButtonClassName="bg-blue-700"
      disabled={approveGovernmentAllocationEntryIsPending}
      title="Você tem certeza?"
      titleClass="text-2xl font-bold mb-2"
      subtitle={governmentAllocationKind === 'pre_paid' ? 'Esse empenho será aprovado.' : 'Essa cota será aprovada.'}
      body={baseError ? <p className="text-sm text-danger-soft">{baseError}</p> : undefined}
    />
  )
}
